const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
const paramsSchema = z.object({
  loopId: z.coerce.number().int().positive()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations')({
  params: paramsSchema,
  beforeLoad: async ({
    context: {
      flags
    },
    params
  }) => {
    if (!flags.loopSidebar) {
      throw redirect({
        to: '/org/$org',
        params: {
          org: params.org
        }
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});